import React from 'react'
import Special from '../components/SpecialTransformers/Special'
import {SlideShowG} from '../components/SpecialTransformers/SlideShowG/SlideShowG'
import RDSO from '../components/SpecialTransformers/Services/services'


const SpecialTransfromer = () => {
  return (
    <>
    <div className='TractionDIV'/>
    <Special/>
    <SlideShowG/>
    <RDSO/>
    </>
  )
}

export default SpecialTransfromer